/* app/js/src/components/alerts/alerts-type/alerts-type.component.scss */
.report-link {
  color: #ef5350;
  font-weight: bold;
  font-size: 10px;
  line-height: 1.8;
  letter-spacing: 0.1px;
}
.report-link:hover {
  text-decoration: underline;
}
.no-issues {
  color: green !important;
  font-weight: bold;
  font-size: 10px;
  line-height: 1.8;
  letter-spacing: 0.1px;
  text-decoration: none !important;
}
.no-issues:hover {
  text-decoration: none !important;
}
.no-cursor {
  cursor: default;
}
.head {
  color: white;
  font-size: 13px;
}
/*# sourceMappingURL=alerts-type.component.css.map */
